  import React, { useState } from "react";
  import * as XLSX from "xlsx";
  import { Modal, Button, Row, Col } from "react-bootstrap";
  import Navbar from "./navbar";
  import TopNavbar from "./topnavbar";
  import Footer from "./footer";
  import "../App.css";
  import axios from "axios";
  import { useNavigate } from "react-router-dom";
  import * as emailjs from "emailjs-com";
  import bcrypt from "bcryptjs";
  import RefTableManager from "./RefTableManager";
  // Import the generateUniquePassword function
  const { generateUniquePassword } = require("./utils");

  // Initialize EmailJS with your user ID
  emailjs.init("5CED_P6z3JRHEcgVq");
  // Define email service ID and template ID
  const emailServiceID = "service_xfudh5t";
  const emailTemplateID = "template_j6qm7ym";

  const ROWS_PER_PAGE = 10;

  const optionalFields = ["MiddleName", "MaidenName"]; 

  const requiredFields = [
    "EmployeeId",
    "FirstName",
    "MiddleName",
    "LastName",
    "Birthdate",
    "Gender",
    "MaritalStatus",
    "HDMF",
    "PHIC",
    "SSS",
    "TIN",
    "ContactNumber",
    "EmailAddress",
    "HmoProvider",
    "HmoPolicyNumber",
    "DUCode",
    "ProjectCode",
    "ShiftCode",
    "DepartmentName",
    "DateHired",
    "Level",
    "Position",
    "EmploymentStatus",
    "EmployeeStatus",
    "WorkWeekType",
    "WorkArrangement",
    "RateClass",
    "Rate",
    "ManagerID",
    "ManagerName",
    "PMPICID",
    "PMPICIDName",
    "DUHID",
    "DUHName",
    "Facility",
    "EmployeeRole",
    "EmployeeCategory",
    "Role"
  ];

  

  const updateTemplates = {
    personalDetails: [
      "EmployeeId", "FirstName", "MiddleName", "LastName", "MaidenName",
      "Birthdate", "Gender", "MaritalStatus", "SSS", "PHIC", "HDMF",
      "TIN", "EmailAddress", "HmoProvider", "HmoPolicyNumber"
    ],

    employeeInfo: [
      "EmployeeId", "HRANID", "DateHired", "Level", "EmploymentStatus",
      "EmployeeStatus", "WorkWeekType", "WorkArrangement", "RateClass", "Rate",
      "ManagerID", "ManagerName", "PMPICID", "PMPICIDName", "DUHID", "DUHName",
      "IsManager", "IsPMPIC", "IsIndividualContributor", "IsActive",
      "HRANType", "TITOType", "Position", "IsDUHead", "Facility",
      "EmployeeRole", "EmployeeCategory",
      "DUCode",
      "DepartmentName",
      "ProjectCode",
      "ShiftCode"
    ],

    employeeContactAddress: [
      "EmployeeId", "ContactNumber", "SecondaryContactNum", "HouseNumber",
      "Barangay", "CityMunicipality", "Province",
      "Region", "Country", "ZipCode", "Landmark"
    ],

    emergencyContactAddress: [
      "EmployeeId", "EmContactFullName", "ContactNumber", "SecondaryContactNum",
      "HouseNumber", "Barangay", "CityMunicipality",
      "Province", "Region", "Country", "ZipCode", "Landmark"
    
    ],

    education: [
      "EmployeeId", "EducationLevel", "School", "Degree", "MajorCourse",
      "HonorRank", "UnitsEarned", "DateFrom", "DateTo", "Session",
      "MonthCompleted", "Completed"
    ],

    dependent: [
      "EmployeeId", "FullName", "Relationship", "DateOfBirth", "Occupation",
      "Address", "City", "DepProvince", "PostalCode", "PhoneNum",
      "Beneficiary", "BeneficiaryDate", "Insurance", "InsuranceDate",
      "Remarks", "CompanyPaid", "HMOProvider", "HMOPolicyNumber", "TypeOfCoverage"
    ],

    compensationBenefits: [
      "EmployeeId", "Salary", "DailyEquivalent", "MonthlyEquivalent",
      "AnnualEquivalent", "RiceMonthly", "RiceAnnual", "RiceDifferentialAnnual",
      "UniformAnnual", "LeaveDays", "LaundryAllowance", "CommAllowance",
      "CommAllowanceType", "CashGift", "MedicalInsurance", "FreeHMODependent",
      "MBL", "LifeInsurance", "Beneficiaries", "PersonalAccidentInsuranceBenefit",
      "PWDIDNumber", "TendopayRegistered", "CanteenUID", "CanteenCreditLimit",
      "CanteenBarcode", "DAPMembershipNumber", "DAPDependents",
      "Stat_SSSNumber", "Stat_SSSMonthlyContribution", "Stat_PagIbigNumber",
      "Stat_PagIbigMonthlyContribution", "Stat_PHICNumber",
      "Stat_PHICMonthlyContribution", "Stat_TINNumber"
    ]
  };
  const NewHireUpload = () => {
    // State for handling file to insert to the database
    const dateFields = [
      "Birthdate",
      "DateHired",
      "DateFrom",
      "DateTo",
      "DateOfBirth",
      "BeneficiaryDate",
      "InsuranceDate"
    ];

    const [file, setFile] = useState(null);
    const [excelData, setExcelData] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [activeTab, setActiveTab] = useState("upload");
    const [editModalShow, setEditModalShow] = useState(false);
    const [editRowData, setEditRowData] = useState(null);
    const [editedData, setEditedData] = useState({});
    // Pagination state for Preview
    const [previewPage, setPreviewPage] = useState(1);
    // State for handling update file
    const [updateFile, setUpdateFile] = useState(null);
    const [selectedUpdateSection, setSelectedUpdateSection] = useState("personalDetails");
    const [updateExcelData, setUpdateExcelData] = useState([]);
    const [showUpdatePreview, setShowUpdatePreview] = useState(false);
    const [editUpdateModalShow, setEditUpdateModalShow] = useState(false);
    const [editUpdateRowData, setEditUpdateRowData] = useState(null);
    const [editedUpdateData, setEditedUpdateData] = useState({});

    // Pagination state for Update Preview
    const [updatePreviewPage, setUpdatePreviewPage] = useState(1);
    // Search filter for Update Preview table
    const [updateSearchQuery, setUpdateSearchQuery] = useState("");
    // Track which employee IDs have been edited in the update preview
    const [editedEmployeeIds, setEditedEmployeeIds] = useState(new Set());
    const [isADAuth, setIsADAuth] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [batchHistory, setBatchHistory] = useState([]);
    const [refOptions, setRefOptions] = useState({
      deliveryUnits: [],
      projects: [],
      shifts: [],
      departments: [],
      positions: [],
    });

    const navigate = useNavigate();
    const loggedInUser = `${sessionStorage.getItem("firstName") || ""} ${sessionStorage.getItem("lastName") || ""}`.trim() || "HRAdmin";
    // ── Pagination helpers ──────────────────────────────────────────────────────

    const paginate = (data, page) => {
      const start = (page - 1) * ROWS_PER_PAGE;
      return data.slice(start, start + ROWS_PER_PAGE);
    };

    const totalPages = (data) => Math.ceil(data.length / ROWS_PER_PAGE);

    const PaginationControls = ({ page, setPage, data }) => {
      const total = totalPages(data);
      return (
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span className="text-muted small">
            Showing {Math.min((page - 1) * ROWS_PER_PAGE + 1, data.length)}–
            {Math.min(page * ROWS_PER_PAGE, data.length)} of {data.length} rows
          </span>
          <div>
            <button
              className="btn btn-sm btn-outline-secondary mr-2"
              onClick={() => setPage((p) => Math.max(p - 1, 1))}
              disabled={page === 1}
            >
              &laquo; Previous
            </button>
            <span className="mx-2">
              Page {page} of {total}
            </span>
            <button
              className="btn btn-sm btn-outline-secondary ml-2"
              onClick={() => setPage((p) => Math.min(p + 1, total))}
              disabled={page === total}
            >
              Next &raquo;
            </button>
          </div>
        </div>
      );
    };

    // ── File handlers ───────────────────────────────────────────────────────────

    const handleDownloadTemplate = () => {
      const templateRow = {};

      requiredFields.forEach((field) => {
        templateRow[field] = "";
      });

      const worksheet = XLSX.utils.json_to_sheet([templateRow], {
        header: requiredFields,
      });

      // SET COLUMN WIDTHS HERE
      worksheet["!cols"] = requiredFields.map((field) => {
        let width = 20; // default width

        if (field.toLowerCase().includes("id")) width = 18;
        if (field.toLowerCase().includes("name")) width = 25;
        if (field.toLowerCase().includes("date")) width = 18;
        if (field.toLowerCase().includes("email")) width = 30;
        if (field.toLowerCase().includes("code")) width = 18;
        if (field.toLowerCase().includes("number")) width = 20;

        return { wch: width };
      });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "New Hire Template");

      XLSX.writeFile(workbook, "NewHireUploadTemplate.xlsx");
    };

    const handleDownloadUpdateTemplate = () => {
      const fields = updateTemplates[selectedUpdateSection];

      const templateRow = {};
      fields.forEach((field) => {
        templateRow[field] = "";
      });

      const worksheet = XLSX.utils.json_to_sheet([templateRow], {
        header: fields,
      });

      worksheet["!cols"] = fields.map((field) => {
        let width = 20;

        if (field.toLowerCase().includes("id")) width = 18;
        if (field.toLowerCase().includes("name")) width = 25;
        if (field.toLowerCase().includes("date")) width = 18;
        if (field.toLowerCase().includes("email")) width = 30;

        return { wch: width };
      });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Update Template");

      const fileNames = {
        personalDetails: "Employee_Personal_Details_Template.xlsx",
        employeeInfo: "Employment_Information_Template.xlsx",
        employeeContactAddress: "Employee_Contact_Address_Template.xlsx",
        emergencyContactAddress: "Emergency_Contact_Address_Template.xlsx",
        education: "Education_Template.xlsx",
        dependent: "Dependent_Template.xlsx",
        compensationBenefits: "Compensation_Benefits_Template.xlsx",
      };

      XLSX.writeFile(workbook, fileNames[selectedUpdateSection] || `${selectedUpdateSection}_Template.xlsx`);
    };
    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      setShowPreview(false);
      setActiveTab("upload");
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!file) {
        alert("No File Selected");
        return;
      }

      const fileType = file.type;
      if (
        fileType !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        alert("Please select an Excel file.");
        return;
      }

      try {
        const data = await readFile(file);
        const parsedData = parseExcelData(data);
        setExcelData(parsedData);
        setPreviewPage(1); // reset to first page on new upload
        setShowPreview(true);
        setActiveTab("preview");
      } catch (error) {
        console.error("Error occurred while reading the file:", error);
        setExcelData([]);
        setShowPreview(false);
        setActiveTab("upload");
        alert("Error occurred while reading the file. Please try again.");
      }
    };

    const readFile = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(new Uint8Array(e.target.result));
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
      });
    };

    const parseCellValue = (value) => {
      return value !== undefined && value !== null ? value.toString() : "";
    };

    const parseExcelData = (data) => {
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const rows = XLSX.utils.sheet_to_json(sheet, {
        defval: "",   // ← THIS is the key fix
        raw: false
      });

      if (rows.length === 0) return [];

      return rows.filter(row =>
        Object.values(row).some(v => v !== "" )
      );
    };

    // const convertExcelDateToDate = (excelDateValue) => {
    //   if (!excelDateValue) return null;
    //   const excelDateNumber = parseFloat(excelDateValue);
    //   if (isNaN(excelDateNumber)) return null;
    //   const excelDateInMS = (excelDateNumber - 25569) * 86400 * 1000;
    //   const dateObj = new Date(excelDateInMS);
    //   return dateObj.toLocaleDateString();
    // };

   const formatDate = (value) => {
  if (!value) return "";
  if (value === "" || value === null || value === undefined) return "";

  // Already a valid yyyy-mm-dd string
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

  // mm/dd/yyyy string
  if (typeof value === "string" && value.includes("/")) {
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().split("T")[0];
  }

  // Excel serial number
  const num = Number(value);
  if (!isNaN(num) && num > 0) {
    const date = new Date((num - 25569) * 86400 * 1000);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
  }

  return "";
};

    // const handleEditClick = (rowData) => {
    //   setEditRowData(rowData);
    //   setEditedData(rowData);
    //   setEditModalShow(true);
    // };

    const handleEditClick = async (rowData) => {
      await fetchRefOptions();

      setEditRowData(rowData);
      setEditedData({
        ...rowData,
        Birthdate: formatDate(rowData.Birthdate),
        DateHired: formatDate(rowData.DateHired),
      });
      setEditModalShow(true);
    };


    const handleCloseEditModal = () => {
      setEditModalShow(false);
    };

    // const handleInputChange = (e) => {
    //   const { name, value } = e.target;
    //   setEditedData({ ...editedData, [name]: value });
    // };

  const handleInputChange = (e) => {
      const { name, value } = e.target;

      setEditedData(prev => ({
        ...prev,
        [name]: value,
        ...(name === "Position" && {
          Level: refOptions.positions.find(
            p => p.Position?.trim().toLowerCase() === value.trim().toLowerCase()
          )?.Level || ""
        })
      }));
    };

    const handleSaveChanges = () => {
      const updatedData = excelData.map((row) => {
        if (row === editRowData) {
          return { ...row, ...editedData };
        }
        return row;
      });

      setExcelData(updatedData);

      setEditedEmployeeIds(prev => new Set(prev).add(String(editedData.EmployeeId)));

      setEditModalShow(false);
    };

    const sendEmailNotification = async (templateParams) => {
      try {
        await emailjs.send(emailServiceID, emailTemplateID, templateParams);
        console.log("Email sent successfully");
      } catch (error) {
        console.error("Error sending email:", error);
      }
    };

    // const isFieldEmpty = (value) => {
    //   return value === null || value === "";
    // };

    const isFieldEmpty = (value) => {
      return value === null || value === undefined || value.toString().trim() === "";
    };

    const handleSaveData = async () => {
  // ── Sync checks first (no spinner yet) ──
  const missingColumns = requiredFields.filter(
    (field) => !Object.keys(excelData[0] || {}).includes(field)
  );
  if (missingColumns.length > 0) {
    alert(`Missing required columns: ${missingColumns.join(", ")}`);
    return;
  }

  const hasEmptyFields = excelData.some((row) =>
    requiredFields.filter(f => !optionalFields.includes(f)).some((field) => isFieldEmpty(row[field]))
  );
  if (hasEmptyFields) {
    alert("One or more required fields are empty. Please fill in all fields.");
    return;
  }

  const invalidRoles = excelData.filter((row) => {
    const role = row.Role?.trim();
    return role !== "HRAdmin" && role !== "Employee";
  });
  if (invalidRoles.length > 0) {
    const invalidRoleRows = invalidRoles.map((_, index) => `Row ${index + 1}`);
    alert(
      `Invalid Role values in rows: ${invalidRoleRows.join(", ")}. Role must be 'HRAdmin' or 'Employee'.`
    );
    return;
  }

  // ── Now start spinner and do async work ──
  setIsSaving(true);
  try {
    // ONE batch call instead of 1000 individual calls
    const ids = excelData.map((row) => row.EmployeeId);
    const dupeResponse = await axios.post("/api/checkDuplicateEmployeeIds", { ids });
    const duplicateEmployeeIds = dupeResponse.data.duplicates;

    if (duplicateEmployeeIds.length > 0) {
      throw new Error(
        `Duplicate Employee IDs detected: ${duplicateEmployeeIds.join(", ")}. Each Employee ID must be unique.`
      );
    }

    const formattedData = excelData.map((row) => {
      const formattedRow = { ...row };
      ["Birthdate", "DateHired"].forEach((field) => {
        formattedRow[field] = formatDate(row[field]);
      });
      return formattedRow;
    });

    const dataWithPasswords = formattedData.map((row) => {
      const cleanedRow = {};
      requiredFields.forEach((field) => {
        cleanedRow[field] = row[field];
      });
      const uniquePassword = isADAuth ? "ADlogin@!0987654321" : generateUniquePassword();
      return { ...cleanedRow, Password: uniquePassword };
    });

    const response = await axios.post("/api/uploadNewHire", dataWithPasswords, {
      headers: { "Content-Type": "application/json" },
    });

    if (response.status !== 200) {
      throw new Error("Failed to save data");
    }

    // Clear state BEFORE alert so spinner stops immediately
    setShowPreview(false);
    setActiveTab("upload");
    setExcelData([]);
    setPreviewPage(1);
    setIsSaving(false);
    navigate("/reports");

    // Fire and forget — save batch history in background
    axios.post("/api/uploadBatchHistory", {
      fileName: file?.name || "Unknown File",
      importedBy: loggedInUser,
      facility: dataWithPasswords[0]?.Facility || "",
      employees: dataWithPasswords.map(r => ({
        empId: r.EmployeeId,
        employeeName: `${r.LastName}, ${r.FirstName} ${r.MiddleName ? r.MiddleName.charAt(0) + '.' : ''}`.toUpperCase().trim()
      }))
    }).catch(err => console.error("Failed to save batch history:", err));

    setTimeout(() => {
      alert("Data has been successfully uploaded and Email sent successfully to account user!");
    }, 100); // tiny delay lets React re-render before alert blocks
    } catch (error) {
      console.error("Error saving data:", error);
      alert(error.message);
    } finally {
      setIsSaving(false);
    }
    };

    // ── Update file handlers ────────────────────────────────────────────────────

    const handleUpdateFileChange = (event) => {
      const file = event.target.files[0];
      setUpdateFile(file);

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const parsedData = parseUpdateExcelData(data); // ← use the fixed function
        setUpdateExcelData(parsedData);
        setUpdatePreviewPage(1);
        setUpdateSearchQuery("");
        setShowUpdatePreview(true);
        setActiveTab("updatePreview");
      };
      reader.readAsArrayBuffer(file);
    };
        const handleUpdateSubmit = async (e) => {
      e.preventDefault();

      if (!updateFile) {
        alert("No File Selected");
        return;
      }

      const fileType = updateFile.type;
      if (
        fileType !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        alert("Please select an Excel file.");
        return;
      }

      try {
        const data = await readUpdateFile(updateFile);
        const parsedData = parseUpdateExcelData(data);
        setUpdateExcelData(parsedData);
        setUpdatePreviewPage(1); // reset to first page
        setUpdateSearchQuery(""); // reset search on new upload
        setShowUpdatePreview(true);
        setActiveTab("updatePreview");
      } catch (error) {
        console.error("Error occurred while reading the file:", error);
        setUpdateExcelData([]);
        setShowUpdatePreview(false);
        setActiveTab("update");
        alert("Error occurred while reading the file. Please try again.");
      }
    };

    const readUpdateFile = (updateFile) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(new Uint8Array(e.target.result));
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(updateFile);
      });
    };

    const parseUpdateCellValue = (value) => {
      return value !== undefined && value !== null ? value.toString() : "";
    };

    const parseUpdateExcelData = (data) => {
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];

    const rows = XLSX.utils.sheet_to_json(sheet, {
      defval: "",
      raw: true  // ← keep raw numeric/boolean values as-is
    });

    if (rows.length === 0) return [];

    return rows
      .filter(row => Object.values(row).some(v => v !== ""))
      .map(row => {
        const cleaned = {};
        Object.keys(row).forEach(key => {
          const val = row[key];
          // Convert to string but preserve "0" and "1" correctly
          cleaned[key] = val !== undefined && val !== null ? String(val) : "";
        });
        return cleaned;
      });
  };


    const fetchRefOptions = async () => {
      const res = await axios.get("/api/ref/all");
      setRefOptions(res.data);
    };

    // const handleEditUpdateClick = (rowData) => {
    //   setEditUpdateRowData(rowData);
    //   setEditedUpdateData(rowData);
    //   setEditUpdateModalShow(true);
    // };

    const fetchBatchHistory = async () => {
      try {
        const res = await axios.get("/api/uploadBatchHistory");
        setBatchHistory(res.data);
      } catch (err) {
        console.error("Failed to fetch batch history:", err);
      }
    };

  const handleEditUpdateClick = async (rowData) => {
    await fetchRefOptions();

    setEditUpdateRowData(rowData);

    const cleanedRow = { ...rowData };

    dateFields.forEach((field) => {
      if (cleanedRow[field]) {
        cleanedRow[field] = formatDate(cleanedRow[field]);
      }
    });

    setEditedUpdateData(cleanedRow);
    setEditUpdateModalShow(true);
  };

  const handleCloseEditUpdateModal = () => {
    setEditUpdateModalShow(false);
  };

    // const handleUpdateChange = (e) => {
    //   const { name, value } = e.target;
    //   setEditedUpdateData({ ...editedUpdateData, [name]: value });
    // };

    const handleUpdateChange = (e) => {
      const { name, value } = e.target;

      setEditedUpdateData(prev => {
        const selectedPosition = refOptions.positions.find(
          p => p.Position?.trim().toLowerCase() === value.trim().toLowerCase()
        );

        return {
          ...prev,
          [name]: value,
          ...(name === "Position" && {
            Level: selectedPosition?.Level || ""
          })
        };
      });
    };

    const handleSaveUpdateChanges = () => {
    const updatedData = updateExcelData.map((row) => {
      if (String(row.EmployeeId).trim() === String(editUpdateRowData.EmployeeId).trim()) {
        return { ...row, ...editedUpdateData };
      }
      return row;
    });

    setUpdateExcelData(updatedData);

    setEditedEmployeeIds((prev) => {
      const newSet = new Set(prev);
      newSet.add(String(editedUpdateData.EmployeeId).trim());
      return newSet;
    });

    setEditUpdateModalShow(false);
  };

    const handleUpdateEmployeeInfo = async () => {
      setIsUpdating(true);
      try {
        // if (editedEmployeeIds.size === 0) {
        //   alert("No changes detected. Please edit at least one employee record before submitting.");
        //   return;
        // }

        // const editedRows = updateExcelData.filter((row) =>
        //   editedEmployeeIds.has(row.EmployeeId)
        // );

        if (updateExcelData.length === 0) {
          alert("No update data found. Please upload an Excel file first.");
          return;
        }

        const editedRows = updateExcelData.map((row) => {
          const cleaned = {};
          Object.keys(row).forEach((key) => {
            if (row[key] !== undefined && row[key] !== null && String(row[key]).trim() !== "") {
              cleaned[key] = row[key];
            }
          });
          return cleaned;
        });

        const validateBitFields = () => {
          const invalidFields = [];

          editedRows.forEach((row, index) => {
            const validateField = (fieldName, validValues) => {
              // ONLY validate if field exists in Excel
              if (row[fieldName] !== undefined && row[fieldName] !== "") {
                if (!validValues.includes(row[fieldName])) {
                  invalidFields.push(`${fieldName} in row ${index + 1}`);
                }
              }
            };

            validateField("IsManager", ["0", "1", 0, 1]);
            validateField("IsPMPIC", ["0", "1", 0, 1]);
            validateField("IsIndividualContributor", ["0", "1", 0, 1]);
            validateField("IsActive", ["0", "1", 0, 1]);
            validateField("Is_Active", ["0", "1", 0, 1]);
            validateField("is_Active", ["0", "1", 0, 1]);
            validateField("IsDUHead", ["0", "1", 0, 1]);
            validateField("IsPermanent", ["0", "1", 0, 1]);
            validateField("IsEmergency", ["0", "1", 0, 1]);
          });

          if (invalidFields.length > 0) {
            throw new Error(`Invalid values detected:\n${invalidFields.join("\n")}`);
          }
        };

        validateBitFields();

      const formattedData = editedRows.map((row) => {
        const formattedRow = {};

        Object.keys(row).forEach((key) => {
          const v = row[key];
          // Blank strings → null so backend COALESCE preserves existing DB values
          formattedRow[key] = (v === undefined || v === null || String(v).trim() === "")
            ? null
            : String(v).trim();
        });

        dateFields.forEach((field) => {
          if (formattedRow[field]) {
            formattedRow[field] = formatDate(formattedRow[field]);
          }
        });

        return formattedRow;
      });

        const response = await axios.put(
          `/api/updateEmployeeSection/${selectedUpdateSection}/bulk`,
          formattedData,
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.data.status !== "success") {
          throw new Error(response.data.message || "Failed to update employee information.");
        }

        

      setShowUpdatePreview(false);
      setUpdateExcelData([]);
      setUpdatePreviewPage(1);
      setUpdateSearchQuery("");
      setEditedEmployeeIds(new Set());
      setIsUpdating(false); // stop spinner FIRST
      navigate("/reports");
      setTimeout(() => {
        alert(`Successfully updated ${formattedData.length} employee record(s)!`);
      }, 100);
    } catch (error) {
      console.error("Error updating employee information:", error);
      alert(error.message);
    } finally {
      setIsUpdating(false);
    }
    };

  

    const renderField = (key, data, onChange) => {
    const rawValue = data[key] || "";
    const value = String(rawValue);
    const trimmedValue = value.trim();

      if (key === "DUCode") {
          return (
            <select className="form-control" name={key} value={trimmedValue} onChange={onChange}>
              <option value="">Select DU</option>
              {refOptions.deliveryUnits.map(item => (
                <option key={item.DUCode} value={item.DUCode}>
                  {item.DUCode} - {item.DUName}
                </option>
              ))}
            </select>
          );
        }

        if (key === "ProjectCode") {
          return (
            <select className="form-control" name={key} value={trimmedValue} onChange={onChange}>
              <option value="">Select Project</option>
              {refOptions.projects.map(item => (
                <option key={item.ProjectCode} value={item.ProjectCode}>
                  {item.ProjectCode} - {item.ProjectName}
                </option>
              ))}
            </select>
          );
        }

        if (key === "ShiftCode") {
          return (
            <select className="form-control" name={key} value={trimmedValue} onChange={onChange}>
              <option value="">Select Shift</option>
              {refOptions.shifts.map(item => (
                <option key={item.ShiftCode} value={item.ShiftCode}>
                  {item.ShiftCode} - {item.ShiftName} ({item.ShiftType})
                </option>
              ))}
            </select>
          );
        }

        if (key === "DepartmentName") {
        const deptValue = value.startsWith("[")
          ? value.match(/\[(.*?)\]/)?.[1]
          : refOptions.departments.find(
              d =>
                d.DepartmentDescription?.toLowerCase() === value.toLowerCase() ||
                d.DepartmentCode?.toString() === value
            )?.DepartmentCode || value;

          return (
            <select
              className="form-control"
              name={key}
              value={deptValue || ""}
              onChange={onChange}
            >
              <option value="">Select Department</option>
              {refOptions.departments.map(item => (
                <option key={item.DepartmentCode} value={item.DepartmentCode}>
                  [{item.DepartmentCode}] {item.DepartmentDescription}
                </option>
              ))}
            </select>
          );
        }

        if (key === "Position") {
          return (
            <select className="form-control" name={key} value={trimmedValue}onChange={onChange}>
              <option value="">Select Position</option>
              {refOptions.positions.map(item => (
                <option key={`${item.Position}-${item.Level}`} value={item.Position}>
                  Level {item.Level} - {item.Position}
                </option>
              ))}
            </select>
          );
        }

        if (key === "EmploymentStatus") {
          const options = ["PERMANENT", "PROBATIONARY", "PROJECT BASED", "FIXED TERM"];
          const currentEmploymentStatus = trimmedValue.toUpperCase();
          return (
            <select className="form-control" name={key} value={currentEmploymentStatus} onChange={onChange}>
              <option value="">Select Employment Status</option>
              {options.map(opt => (
                <option key={opt} value={opt}>
                  {opt.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())}
                </option>
              ))}
            </select>
          );
        }

        if (key === "EmployeeStatus") {
          const options = ["ACTIVE", "SUSPENSION", "ON MATERNITY LEAVE", "ABSENT W/O LEAVE", "ABSENT WITH LEAVE", "SICK LEAVE"];
          const currentEmployeeStatus = trimmedValue.toUpperCase();

          return (
            <select className="form-control" name={key} value={currentEmployeeStatus} onChange={onChange}>
              <option value="">Select Employee Status</option>
              {options.map(opt => (
                <option key={opt} value={opt}>
                  {opt.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())}
                </option>
              ))}
            </select>
          );
        }

        if (key === "Role") {
          return (
            <select className="form-control" name={key} value={trimmedValue} onChange={onChange}>
              <option value="">Select Role</option>
              <option value="Employee">Employee</option>
              <option value="HRAdmin">HRAdmin</option>
            </select>
          );
        }

        if (key === "RateClass") {
          return (
            <select className="form-control" name={key} value={trimmedValue} onChange={onChange}>
              <option value="">Select Rate Class</option>
              <option value="Daily Rate">Daily Rate</option>
              <option value="Monthly Rate">Monthly Rate</option>
            </select>
          );
        }

        if (key === "EmployeeRole") {
        return (
          <select className="form-control" name={key} value={trimmedValue} onChange={onChange}>
            <option value="">Select Employee Role</option>
            <option value="Individual Contributor">Individual Contributor</option>
            <option value="People Manager">People Manager</option>
          </select>
        );
      }

        if (key === "EmployeeCategory") {
        return (
          <select className="form-control" name={key} value={trimmedValue} onChange={onChange}>
            <option value="">Select Employee Category</option>
            <option value="Associate">Associate</option>
            <option value="Manager">Manager</option>
          </select>
        );
      }
      return (
        <input
          type={dateFields.includes(key) ? "date" : "text"}
          className="form-control auto-width-input"
          name={key}
          value={value}
          onChange={onChange}
          readOnly={key === "Level"}
        />
      );
    };
    // ── Render ──────────────────────────────────────────────────────────────────

    return (
      <div>
        <div id="wrapper">
          {/* Sidebar */}
          <Navbar />
          {/* Content Wrapper */}
          <div id="content-wrapper" className="d-flex flex-column">
            {/* Main Content */}
            <div id="content">
              {/* Topbar */}
              <TopNavbar />
              {/* Start of Page Content */}
              <div className="container-fluid">
                <div className="row justify-content-center">
                  <div className="col-xl-12 col-lg-12">
                    <div className="card shadow mb-4">
                      <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeTab === "upload" ? "active" : ""}`}
                              id="upload-tab"
                              data-toggle="tab"
                              href="#uploadForm"
                              role="tab"
                              aria-controls="uploadForm"
                              aria-selected={activeTab === "upload"}
                              onClick={() => {
                                setActiveTab("upload");
                                setFile(null);
                                setExcelData([]);
                                setShowPreview(false);
                                setPreviewPage(1);
                                setEditedEmployeeIds(new Set());
                              }}
                            >
                              Upload
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeTab === "preview" ? "active" : ""}`}
                              id="preview-tab"
                              data-toggle="tab"
                              href="#newHireReports"
                              role="tab"
                              aria-controls="newHireReports"
                              aria-selected={activeTab === "preview"}
                              onClick={() => setActiveTab("preview")}
                            >
                              Preview
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeTab === "update" ? "active" : ""}`}
                              id="update-tab"
                              data-toggle="tab"
                              href="#updateForm"
                              role="tab"
                              aria-controls="updateForm"
                              aria-selected={activeTab === "update"}
                              onClick={() => {
                                setActiveTab("update");
                                setUpdateFile(null);
                                setUpdateExcelData([]);
                                setShowUpdatePreview(false);
                                setEditedEmployeeIds(new Set());
                              }}
                            >
                              Update
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeTab === "updatePreview" ? "active" : ""}`}
                              id="updatePreview-tab"
                              data-toggle="tab"
                              href="#updatePreview"
                              role="tab"
                              aria-controls="updatePreview"
                              aria-selected={activeTab === "updatePreview"}
                              onClick={() => setActiveTab("updatePreview")}
                            >
                              Update Preview
                            </a>
                          </li>
                          <li className="nav-item">
                            <a                         
                              className={`nav-link ${activeTab === "history" ? "active" : ""}`}
                              id="history-tab"
                              data-toggle="tab"
                              href="#history"
                              role="tab"
                              aria-controls="history"
                              aria-selected={activeTab === "history"}
                              onClick={() => {
                                setActiveTab("history");
                                fetchBatchHistory();
                              }}
                            >
                               Upload History
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <div className="tab-content">

                          {/* ── Upload Tab ── */}
                          <div
                            className={`tab-pane fade ${activeTab === "upload" ? "show active" : ""}`}
                            id="uploadForm"
                            role="tabpanel"
                            aria-labelledby="upload-tab"
                          >
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "330px" }}>
                              <div
                                className="bg-white border rounded"
                                style={{
                                  width: "560px",
                                  padding: "30px",
                                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                                  borderRadius: "14px",
                                }}
                              >
                                <div className="text-center mb-4">
                                  <div
                                    className="d-inline-flex align-items-center justify-content-center mb-3"
                                    style={{
                                      width: "56px",
                                      height: "56px",
                                      borderRadius: "50%",
                                      backgroundColor: "#eef3ff",
                                      color: "#4e73df",
                                      fontSize: "24px",
                                    }}
                                  >
                                    <i className="fas fa-file-excel"></i>
                                  </div>

                                  <h5 className="font-weight-bold mb-1" style={{ color: "#4b5563" }}>
                                    Upload New Hire File
                                  </h5>
                                  <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                                    Download the Excel template, fill in the required fields, then upload it here.
                                  </p>
                                </div>

                                <form encType="multipart/form-data">
                                  <div className="form-group mb-4">

                                    <div
                                      style={{
                                        border: "1px dashed #cbd5e1",
                                        borderRadius: "10px",
                                        padding: "18px",
                                        backgroundColor: "#f8fafc",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        className="form-control-file"
                                        accept=".xlsx"
                                        key={activeTab}
                                        onChange={handleFileChange}
                                      />
                                      <small className="form-text text-muted mt-2">
                                        Accepted file type: .xlsx only
                                      </small>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-md-6 mb-2">
                                      <button
                                        type="button"
                                        onClick={handleDownloadTemplate}
                                        className="btn btn-outline-success btn-block"
                                        style={{
                                          borderRadius: "10px",
                                          fontWeight: "600",
                                          height: "42px",
                                        }}
                                      >
                                        <i className="fas fa-download mr-2"></i>
                                        Download Template
                                      </button>
                                    </div>

                                    <div className="col-md-6 mb-2">
                                      <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        className="btn btn-primary btn-block"
                                        style={{
                                          borderRadius: "10px",
                                          fontWeight: "600",
                                          height: "42px",
                                        }}
                                      >
                                        <i className="fas fa-upload mr-2"></i>
                                        Upload File
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>

                          {/* ── Preview Tab ── */}
                          <div
                            className={`tab-pane fade ${activeTab === "preview" ? "show active" : ""}`}
                            id="newHireReports"
                            role="tabpanel"
                            aria-labelledby="preview-tab"
                          >
                            <div className="card-body">
                              <div className="table-responsive">
                                {showPreview && excelData.length > 0 ? (
                                  <div>
                                    <h5 className="mb-3 font-weight-bold">
                                      Preview of the Uploaded Data
                                    </h5>
                                    <table className="table table-bordered table-hover">
                                      <thead>
                                        <tr>
                                          <th>ACTION</th>
                                          {Object.keys(excelData[0]).map((header) => (
                                            <th key={header}>{header}</th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {paginate(excelData, previewPage).map((row, index) => (
                                          <tr
                                              key={index}
                                              style={
                                                editedEmployeeIds.has(row.EmployeeId)
                                                  ? { backgroundColor: "#fff3cd" }
                                                  : {}
                                              }
                                            >
                                            <td>
                                              <button
                                                className="update-button btn btn-xs"
                                                onClick={() => handleEditClick(row)}
                                              >
                                                <i className="fas fa-pencil-alt"></i>
                                              </button>
                                            </td>
                                            {Object.keys(row).map((key) => (
                                              <td key={key}>
                                                {dateFields.includes(key) && row[key]
                                                  ? formatDate(row[key])
                                                  : row[key]}
                                              </td>
                                            ))}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>

                                    {/* Pagination Controls */}
                                    <PaginationControls
                                      page={previewPage}
                                      setPage={setPreviewPage}
                                      data={excelData}
                                    />

                                    <div className="text-center mt-3">
                                      <button
                                        className="btn btn-primary mr-2"
                                        onClick={handleSaveData}
                                        disabled={isSaving}
                                      >
                                        {isSaving ? (
                                          <>
                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                            Saving Data...
                                          </>
                                        ) : (
                                          "Submit Data"
                                        )}
                                      </button>
                                    </div>
                                    <br />
                                  </div>
                                ) : (
                                  <div className="text-center">
                                    Upload new file to preview data
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* ── Update Tab ── */}
                          <div className={`tab-pane fade ${activeTab === "update" ? "show active" : ""}`}>
                          <div className="card-body">
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "320px" }}>
                              <div
                                className="bg-white border rounded"
                                style={{
                                  width: "520px",
                                  padding: "28px",
                                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                                  borderRadius: "14px",
                                }}
                              >
                                <div className="text-center mb-4">
                                  <div
                                    className="d-inline-flex align-items-center justify-content-center mb-3"
                                    style={{
                                      width: "52px",
                                      height: "52px",
                                      borderRadius: "50%",
                                      backgroundColor: "#eef3ff",
                                      color: "#4e73df",
                                      fontSize: "22px",
                                    }}
                                  >
                                    <i className="fas fa-sync-alt"></i>
                                  </div>

                                  <h5 className="font-weight-bold mb-1" style={{ color: "#4b5563" }}>
                                    Update Employee Data
                                  </h5>
                                  <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                                    Select the update section, download the template, then upload the completed Excel file.
                                  </p>
                                </div>

                                <form className="user" encType="multipart/form-data">
                                  <div className="form-group mb-3">
                                    <label className="font-weight-bold small mb-2">Update Section</label>
                                    <select
                                      className="form-control"
                                      value={selectedUpdateSection}
                                      onChange={(e) => {
                                        setSelectedUpdateSection(e.target.value);
                                        setUpdateFile(null);
                                        setUpdateExcelData([]);
                                        setShowUpdatePreview(false);
                                        setEditedEmployeeIds(new Set());
                                      }}
                                      style={{ height: "42px", borderRadius: "10px" }}
                                    >
                                      <option value="personalDetails">Employee Personal Details</option>
                                      <option value="employeeInfo">Employement Information</option>
                                      <option value="employeeContactAddress">Employee Contact & Address</option>
                                      <option value="emergencyContactAddress">Emergency Contact & Address</option>
                                      <option value="education">Education</option>
                                      <option value="dependent">Dependent</option>
                                      <option value="compensationBenefits">Compensation Benefits</option>
                                    </select>
                                  </div>

                                  <div className="form-group mb-3">
                                    <label className="font-weight-bold small mb-2">Excel File</label>
                                    <div
                                      style={{
                                        border: "1px dashed #cbd5e1",
                                        borderRadius: "10px",
                                        padding: "16px",
                                        backgroundColor: "#f8fafc",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        className="form-control-file"
                                        accept=".xlsx"
                                        aria-describedby="updateFileHelp"
                                        key={activeTab}
                                        onChange={handleUpdateFileChange}
                                      />
                                      <small id="updateFileHelp" className="form-text text-muted mt-2">
                                        Accepted file type: .xlsx only
                                      </small>
                                    </div>
                                  </div>

                                  <div className="row mt-4">
                                    <div className="col-md-6 mb-2">
                                      <button
                                        type="button"
                                        onClick={handleDownloadUpdateTemplate}
                                        className="btn btn-outline-success btn-block"
                                        style={{
                                          borderRadius: "10px",
                                          fontWeight: "600",
                                          height: "42px",
                                        }}
                                      >
                                        <i className="fas fa-download mr-2"></i>
                                        Download Template
                                      </button>
                                    </div>

                                    <div className="col-md-6 mb-2">
                                      <button
                                        type="submit"
                                        onClick={handleUpdateSubmit}
                                        className="btn btn-primary btn-block"
                                        style={{
                                          borderRadius: "10px",
                                          fontWeight: "600",
                                          height: "42px",
                                        }}
                                      >
                                        <i className="fas fa-upload mr-2"></i>
                                        Upload File
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          
                          <RefTableManager />
                          </div>

                          {/* ── Update Preview Tab ── */}
                          <div
                            className={`tab-pane fade ${activeTab === "updatePreview" ? "show active" : ""}`}
                            id="updatePreview"
                            role="tabpanel"
                            aria-labelledby="updatePreview-tab"
                          >
                            <div className="card-body">
                              <div className="table-responsive">
                                {showUpdatePreview && updateExcelData.length > 0 ? (
                                  <div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                      <h5 className="font-weight-bold mb-0">
                                        Preview of the Updated Data
                                      </h5>
                                      <div className="input-group" style={{ maxWidth: "320px" }}>
                                        <div className="input-group-prepend">
                                          <span className="input-group-text">
                                            <i className="fas fa-search"></i>
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search by Employee ID or Name..."
                                          value={updateSearchQuery}
                                          onChange={(e) => {
                                            setUpdateSearchQuery(e.target.value);
                                            setUpdatePreviewPage(1); // reset to page 1 on search
                                          }}
                                        />
                                        {updateSearchQuery && (
                                          <div className="input-group-append">
                                            <button
                                              className="btn btn-outline-secondary"
                                              onClick={() => {
                                                setUpdateSearchQuery("");
                                                setUpdatePreviewPage(1);
                                              }}
                                            >
                                              &times;
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {(() => {
                                      const filteredUpdateData = updateSearchQuery.trim()
                                        ? updateExcelData.filter((row) => {
                                            const q = updateSearchQuery.toLowerCase();
                                            const idMatch = row.EmployeeId?.toString().toLowerCase().includes(q);
                                            const nameMatch = [row.FirstName, row.LastName, row.MiddleName]
                                              .filter(Boolean)
                                              .join(" ")
                                              .toLowerCase()
                                              .includes(q);
                                            return idMatch || nameMatch;
                                          })
                                        : updateExcelData;
                                      return (
                                        <>
                                          <table className="table table-bordered table-hover">
                                            <thead>
                                              <tr>
                                                <th>ACTION</th>
                                                {Object.keys(updateExcelData[0]).map((header) => (
                                                  <th key={header}>{header}</th>
                                                ))}
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {filteredUpdateData.length > 0 ? (
                                                paginate(filteredUpdateData, updatePreviewPage).map(
                                                  (row, index) => (
                                                    <tr
                                                      key={index}
                                                      style={
                                                        editedEmployeeIds.has(row.EmployeeId)
                                                          ? { backgroundColor: "#fff3cd" }
                                                          : {}
                                                      }
                                                    >
                                                      <td>
                                                        <button
                                                          className="update-button btn btn-xs"
                                                          onClick={() => handleEditUpdateClick(row)}
                                                        >
                                                          <i className="fas fa-pencil-alt"></i>
                                                        </button>
                                                      </td>
                                                      {Object.keys(row).map((key) => (
                                                        <td key={key}>
                                                          {dateFields.includes(key) && row[key]
                                                            ? formatDate(row[key])
                                                            : row[key]}
                                                        </td>
                                                      ))}
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan={Object.keys(updateExcelData[0]).length + 1}
                                                    className="text-center text-muted py-3"
                                                  >
                                                    No records match your search.
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                          <PaginationControls
                                            page={updatePreviewPage}
                                            setPage={setUpdatePreviewPage}
                                            data={filteredUpdateData}
                                          />
                                        </>
                                      );
                                    })()}

                                                                      <div className="text-center mt-3">
                                      <button
                                        className="btn btn-primary mr-2"
                                        onClick={handleUpdateEmployeeInfo}
                                        disabled={isUpdating}
                                      >
                                        {isUpdating ? (
                                          <>
                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                            Updating Data...
                                          </>
                                        ) : (
                                          <>
                                  
                                            Update Data
                                          </>
                                        )}
                                      </button>
                                    </div>
                                    <br />
                                  </div>
                                ) : (
                                  <div className="text-center">
                                    Upload file to update to preview data
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* ── History Tab ── */}
                          <div
                            className={`tab-pane fade ${activeTab === "history" ? "show active" : ""}`}
                            id="history"
                            role="tabpanel"
                          >
                            <div className="card-body">
                             <div className="d-flex justify-content-end mb-3">
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={fetchBatchHistory}
                              >
                                <i className="fas fa-sync-alt mr-1"></i> Refresh
                              </button>
                             </div>
                              {batchHistory.length === 0 ? (
                                <div className="text-center text-muted py-4">No upload history found.</div>
                              ) : (
                                <table className="table table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>File Name</th>
                                      <th>Uploaded By</th>
                                      <th>Facility</th>
                                      <th>Date & Time</th>
                                      <th>Total Records</th>
                                      <th>Status</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {batchHistory.map((batch, index) => (
                                      <tr key={batch.ImportID}>
                                        <td>{index + 1}</td> 
                                        <td>{batch.FileName}</td>
                                        <td>{batch.ImportedBy}</td>
                                        <td>{batch.Facility}</td>
                                        <td>{new Date(batch.ImportDateTime).toLocaleString()}</td>
                                        <td>{batch.TotalRecords}</td>
                                        <td>
                                          <span className={`badge ${batch.Status === "Success" ? "badge-success" : "badge-danger"}`}>
                                            {batch.Status}
                                          </span>
                                        </td>
                                        <td>
                                          <button
                                              className="btn btn-danger btn-sm"
                                              disabled={isDeleting}
                                              onClick={async () => {
                                                if (!window.confirm(
                                                  `Delete all ${batch.TotalRecords} employee(s) from "${batch.FileName}"?\n\nThis cannot be undone.`
                                                )) return;
                                                setIsDeleting(true);
                                                try {
                                                  const res = await axios.delete(`/api/uploadBatchHistory/${batch.ImportID}`, {
                                                    data: { deletedBy: loggedInUser }
                                                  });
                                                  alert(res.data.message);
                                                  fetchBatchHistory();
                                                } catch (err) {
                                                  alert(err.response?.data?.error || err.message);
                                                } finally {
                                                  setIsDeleting(false);
                                                }
                                              }}
                                            >
                                              {isDeleting ? (
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                              ) : (
                                                <i className="fas fa-trash"></i>
                                              )}
                                            </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                          {/* ── END History Tab ── */}

                        </div> {/* end tab-content */}
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.container-fluid */}
            </div>
            {/* Footer */}
            <Footer />
          </div>
        </div>

        {/* ── Edit Modal (Insert) ── */}
        <Modal show={editModalShow} onHide={handleCloseEditModal} centered dialogClassName="custom-modal">
          <Modal.Header>
            <Modal.Title>Update employee information</Modal.Title>
            <Button variant="default" onClick={handleCloseEditModal}>X</Button>
          </Modal.Header>
       <Modal.Body>
          {editRowData && (
            <div>
              {/* Personal Information */}
              <h6 className="font-weight-bold mb-3 mt-2" style={{ color: "#4e73df", borderBottom: "2px solid #4e73df", paddingBottom: "6px" }}>
                Personal Information
              </h6>
              <Row>
                {["EmployeeId","FirstName","MiddleName","LastName","Birthdate","Gender","MaritalStatus","SSS","PHIC","HDMF","TIN","EmailAddress","HmoProvider","HmoPolicyNumber", "ContactNumber"].map((key) => (
                  key in editedData && (
                    <Col key={key} md={4}>
                      <div className="form-group">
                        <label htmlFor={key}>
                          {key}{" "}
                         {requiredFields.includes(key) && !optionalFields.includes(key) && isFieldEmpty(editedData[key]) && (
                            <span style={{ color: "red" }}> *</span>
                          )}
                        </label>
                        {renderField(key, editedData, handleInputChange)}
                      </div>
                    </Col>
                  )
                ))}
              </Row>

              {/* Employment Information */}
              <h6 className="font-weight-bold mb-3 mt-4" style={{ color: "#4e73df", borderBottom: "2px solid #4e73df", paddingBottom: "6px" }}>
                Employment Information
              </h6>
              <Row>
                {["DUCode","ProjectCode","ShiftCode","DepartmentName","DateHired","Level","Position","EmploymentStatus","EmployeeStatus","WorkWeekType","WorkArrangement","RateClass","Rate","ManagerID","ManagerName","PMPICID","PMPICIDName","DUHID","DUHName","Facility","EmployeeRole","EmployeeCategory","Role"].map((key) => (
                  key in editedData && (
                    <Col key={key} md={4}>
                      <div className="form-group">
                        <label htmlFor={key}>
                          {key}{" "}
                          {requiredFields.includes(key) && !optionalFields.includes(key) && isFieldEmpty(editedData[key]) && (
                            <span style={{ color: "red" }}> *</span>
                          )}
                        </label>
                        {renderField(key, editedData, handleInputChange)}
                      </div>
                    </Col>
                  )
                ))}
              </Row>
            </div>
          )}
        </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseEditModal}>Close</Button>
            <Button variant="primary" onClick={handleSaveChanges}>Save Changes</Button>
          </Modal.Footer>
        </Modal>

        {/* ── Edit Modal (Update) ── */}
        <Modal show={editUpdateModalShow} onHide={handleCloseEditUpdateModal} centered dialogClassName="custom-modal">
          <Modal.Header>
            <Modal.Title>Update employee information</Modal.Title>
            <Button variant="default" onClick={handleCloseEditUpdateModal}>X</Button>
          </Modal.Header>
          <Modal.Body>
            {editUpdateRowData && (
              <div>
                <Row>
                  {Object.keys(editUpdateRowData).map((key) => (
                    <Col key={key} md={4}>
                      <div className="form-group">
                        <label htmlFor={key}>
                          {key}{" "}
                        {key === "EmployeeId" && isFieldEmpty(editedData[key]) && isFieldEmpty(editedUpdateData[key]) && (
                           <span style={{ color: "red" }}> * </span>
                        )}
                        </label>
                        {/* <input
                          type="text"
                          className="form-control auto-width-input"
                          name={key}
                          value={editedUpdateData[key] || ""}
                          onChange={handleUpdateChange}
                        /> */}
                        {renderField(key, editedUpdateData, handleUpdateChange)}
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseEditUpdateModal}>Close</Button>
            <Button variant="primary" onClick={handleSaveUpdateChanges}>Save Changes</Button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  };

  export default NewHireUpload;